import { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet-async";

import { FiChevronDown } from "react-icons/fi";

import useStyles from "./styles";
import Select from "Components/Select";

import actions from "store/actions";

import _ from "lodash";

import ls from "Localization";
import { State } from "store/reducers";
import { UserState } from "store/reducers/user";
import IUser from "Types/User";
import { MeiLogisticOperatorStatus } from "Types/IMei";
import { MeiState } from "store/reducers/mei";

const ls2: any = ls;

function MeiOfLogisticOperator() {
	const dispatch = useDispatch<any>();
	const classes = useStyles({});

	useEffect(() => {
		dispatch(actions.mei.clearValues());
		dispatch(actions.mei.getMeisForLogisticOperator());
	}, [dispatch]);

	const [showInfoPanel, setShowInfoPanel] = useState(true);
	const [selected, setSelected] = useState([]);

	const { items } = useSelector<State, MeiState>(s => s.mei);

	const changeStatus = (
		status: MeiLogisticOperatorStatus,
		item: IUser | any
	) => {
		dispatch(
			actions.mei.changeLogisticOperatorStatus(item._id, status, err => {
				if (err) {
					alert(err);
				}
			})
		);
	};

	return (
		<div>
			<Helmet>
				<title>
					{ls.meis} | {ls.appName}
				</title>
			</Helmet>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Accordion
						TransitionProps={{ unmountOnExit: true }}
						expanded={showInfoPanel}
						onChange={() => setShowInfoPanel(prev => !prev)}
					>
						<AccordionSummary
							expandIcon={<FiChevronDown />}
							aria-controls="finishes-content"
							id="finishes-header"
						>
							<Typography className={classes.heading} variant="h6">
								{ls.meis}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell>Nome</TableCell>
										<TableCell>Status</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{items.map(c => {
										return (
											<TableRow key={c._id}>
												<TableCell>
													<b>
														{c.businessName} - {c.cnpj}
													</b>
												</TableCell>
												<TableCell>
													<Select
														id="logisticOperatorStatus"
														name=""
														hideLabel
														value={c.logisticOperatorStatus?.toString() ?? "No"}
														variant="standard"
														onChange={(_, v) => changeStatus(v, c)}
														options={Object.keys(MeiLogisticOperatorStatus)
															.filter(c => !isNaN(+c))
															.filter(c => +c)
															.map((c: any) => ({
																id: c,
																value: ls2[MeiLogisticOperatorStatus[c]]
															}))}
													/>
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</AccordionDetails>
					</Accordion>
				</Grid>
			</Grid>
		</div>
	);
}

export default MeiOfLogisticOperator;
